export default __webpack_public_path__ + "static/image-profile-card-ca43db675659953fdd2b42083e120a9d.png";